/**
 * Whether choosing a value answers the question right away, without a button to continue: a
 * single choice among buttons or radios
 */
export default function isInstantAnswerField(field: FormField | null): boolean {
    const {
        type = null,
        component = null,
        multiple = false,
    } = (field || {}) as BaseField & { multiple?: boolean };
    return (type === 'buttons' && !multiple) || component === 'radios';
}
